<script>
import TooltipIconBase from './TooltipIconBase.vue';

export default {
  name: 'HelpIcon',
  extends: TooltipIconBase
};
</script>
